import { Text } from "components/Text"

export const Figure = ({ icon, label }) => {
  return (
    <div className="flex space-x-2 items-center">
      <div className="shrink-0">{icon}</div>
      <Text variant="body2">{label}</Text>
    </div>
  )
}
